import './settings';

/**
 * @namespace PIXI
 */

/**
 * String of the current PIXI version.
 * @memberof PIXI
 */
export const VERSION = '$_VERSION';

export * from '@pixi/extensions';
export * from './textures/resources';
export * from './systems';
export * from './IRenderingContext';
export * from './IRenderableObject';
export * from './autoDetectRenderer';
export * from './fragments';
export * from './ISystem';
export * from './Renderer';
export * from './AbstractRenderer';
export * from './framebuffer/Framebuffer';
export * from './framebuffer/GLFramebuffer';
export * from './textures/Texture';
export * from './textures/BaseTexture';
export * from './textures/GLTexture';
export * from './textures/TextureMatrix';
export * from './renderTexture/RenderTexture';
export * from './renderTexture/RenderTexturePool';
export * from './renderTexture/BaseRenderTexture';
export * from './textures/TextureUvs';
export * from './state/State';
export * from './batch/ObjectRenderer';
export * from './batch/AbstractBatchRenderer';
export * from './batch/BatchPluginFactory';
export * from './batch/BatchShaderGenerator';
export * from './batch/BatchGeometry';
export * from './batch/BatchDrawCall';
export * from './batch/BatchTextureArray';
export * from './utils/Quad';
export * from './utils/QuadUv';
export * from './shader/utils/checkMaxIfStatementsInShader';
export * from './shader/utils/uniformParsers';
export * from './shader/utils/generateUniformBufferSync';
export * from './shader/utils/getTestContext';
export * from './shader/utils/generateProgram';
export * from './shader/Shader';
export * from './shader/Program';
export * from './shader/GLProgram';
export * from './shader/UniformGroup';
export * from './mask/MaskData';
export * from './filters/spriteMask/SpriteMaskFilter';
export * from './filters/Filter';
export * from './filters/FilterState';
export * from './filters/IFilterTarget';
export * from './geometry/Attribute';
export * from './geometry/Buffer';
export * from './geometry/Geometry';
export * from './geometry/ViewableBuffer';
export * from './deprecations';
